module.exports = __webpack_public_path__ + "img/ics_f_announce.33ff5c45.svg";